import RemoveFromBlockList from 'views/Setting/BlockList/components/RemoveFromBlockList';
import AddToBlockList from 'views/Setting/BlockList/components/AddToBlockList';
import { buyerNickMask } from 'services/channels/demo';
import { Tooltip } from 'antd';
import { useTranslate } from '@tolgee/react';
import Icon from '@ant-design/icons';
import { ReactComponent as addToBlockListSvgIcon } from 'views/Setting/BlockList/assets/addToBlockList.svg';

interface BlacklistProps {
  conversation: Conversation.Conversation;
}
export function Blacklist(props: BlacklistProps) {
  const { conversation } = props;
  const { t } = useTranslate();
  const {
    blacklistFlag,
    blacklistId,
    buyerNick,
    storeId,
    blacklistScope,
    conversationId,
    channel,
    buyerId,
  } = conversation;

  if (blacklistFlag) {
    return (
      <RemoveFromBlockList
        blacklistId={blacklistId!}
        buyerNick={buyerNickMask(buyerNick)}
        storeId={storeId}
        blockScope={blacklistScope!}
        conversationId={conversationId}
      >
        <Tooltip placement="top" title={t('ViewBlockList.取消拉黑')}>
          <Icon component={addToBlockListSvgIcon} />
        </Tooltip>
      </RemoveFromBlockList>
    );
  }

  return (
    <AddToBlockList
      buyerId={buyerId}
      buyerNick={buyerNickMask(buyerNick)}
      storeId={storeId}
      conversationId={conversationId}
      channel={channel}
    >
      <Tooltip placement="top" title={t('ViewBlockList.拉黑')}>
        <Icon component={addToBlockListSvgIcon} />
      </Tooltip>
    </AddToBlockList>
  );
}
